/**
 * API client per l'analisi immagini diagnostiche.
 *
 * Endpoints:
 * - GET  /api/v1/attachments/{id}/analysis        - Ottieni analisi AI
 * - POST /api/v1/attachments/{id}/analyze          - Forza analisi
 * - POST /api/v1/attachments/{id}/vet-correction   - Salva correzione vet
 */

import axios from 'axios';

export interface ImagingAnalysis {
  id: string;
  attachment_id: string;
  model_used: string;
  findings: string;
  diagnosis: string | null;
  differential: string[] | null;
  accuracy_score: number | null;
  requires_vet_review: boolean;
  vet_correction: string | null;
}

export interface VetCorrectionRequest {
  correction: string;
}

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const imagingApi = {
  /**
   * Ottieni analisi AI per un attachment.
   */
  getAnalysis: async (attachmentId: string): Promise<ImagingAnalysis | null> => {
    const response = await api.get<ImagingAnalysis>(`/attachments/${attachmentId}/analysis`);
    return response.data;
  },

  /**
   * Forza analisi AI su un attachment.
   */
  analyze: async (attachmentId: string): Promise<ImagingAnalysis> => {
    const response = await api.post<ImagingAnalysis>(`/attachments/${attachmentId}/analyze`);
    return response.data;
  },

  /**
   * Salva correzione veterinario.
   */
  saveCorrection: async (attachmentId: string, correction: string): Promise<ImagingAnalysis> => {
    const response = await api.post<ImagingAnalysis>(`/attachments/${attachmentId}/vet-correction`, { correction });
    return response.data;
  },
};
